function zf_ValidateAndSubmit(el) {
  // Multi-step: use our own per-step validation (bypasses zf_CheckMandatory/zf_ValidCheck
  // which depend on zf_MandArray that may load after our script)
  if (window.zfMultiStep && window.zfMultiStep.active) {
    try {
      if (!zf_ValidateStep(window.zfMultiStep.totalSteps)) return false;
    } catch(e) {
      console.error('zf_ValidateStep error:', e);
      return false;
    }

    zf_PushToDataLayer(el);

    // Flag submission so we can show success after Zoho redirects back.
    try { sessionStorage.setItem('zf_submitted', '1'); } catch(e) {}

    return true;
  }

  // Non-multi-step: original Zoho validation flow
  if (zf_CheckMandatory()) {
    if (zf_ValidCheck()) {
      if (isSalesIQIntegrationEnabled) {
        zf_addDataToSalesIQ();
      }
      
      zf_PushToDataLayer(el);

      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function zf_CheckMandatory() {
  for (i = 0; i < zf_MandArray.length; i++) {
    var fieldObj = document.forms.form[zf_MandArray[i]];
    if (fieldObj) {
      if (fieldObj.nodeName != null) {
        if (fieldObj.nodeName == 'OBJECT') {
          if (!zf_MandatoryCheckSignature(fieldObj)) {
            zf_ShowErrorMsg(zf_MandArray[i]);
            return false;
          }
        } else if (((fieldObj.value).replace(/^\s+|\s+$/g, '')).length == 0) {
          if (fieldObj.type == 'file') {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_MandArray[i]);
            return false;
          }
          fieldObj.focus();
          zf_ShowErrorMsg(zf_MandArray[i]);
          return false;
        } else if (fieldObj.nodeName == 'SELECT') { // No I18N
          if (fieldObj.options[fieldObj.selectedIndex].value == '-Select-') {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_MandArray[i]);
            return false;
          }
        } else if (fieldObj.type == 'checkbox' || fieldObj.type == 'radio') {
          if (fieldObj.checked == false) {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_MandArray[i]);
            return false;
          }
        }
      } else {
        var checkedValsCount = 0;
        var inpChoiceElems = fieldObj;
        for (var ii = 0; ii < inpChoiceElems.length; ii++) {
          if (inpChoiceElems[ii].checked === true) {
            checkedValsCount++;
          }
        }
        if (checkedValsCount == 0) {
          inpChoiceElems[0].focus();
          zf_ShowErrorMsg(zf_MandArray[i]);
          return false;
        }
      }
    }
  }
  return true;
}

function zf_ValidCheck() {
  for (var ind = 0; ind < zf_FieldArray.length; ind++) {
    var fieldObj = document.forms.form[zf_FieldArray[ind]];
    if (fieldObj) {
      if (fieldObj.nodeName != null) {
        var checkType = fieldObj.getAttribute("checktype");
        if (checkType == "c2") {
          if (!zf_ValidateNumber(fieldObj)) {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_FieldArray[ind]);
            return false;
          }
        } else if (checkType == "c3") {
          if (!zf_ValidateCurrency(fieldObj) || !zf_ValidateDecimalLength(fieldObj, 10)) {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_FieldArray[ind]);
            return false;
          }
        } else if (checkType == "c4") {
          if (!zf_ValidateDateFormat(fieldObj)) {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_FieldArray[ind]);
            return false;
          }
        } else if (checkType == "c5") {
          if (!zf_ValidateEmailID(fieldObj)) {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_FieldArray[ind]);
            return false;
          }
        } else if (checkType == "c6") {
          if (!zf_ValidateLiveUrl(fieldObj)) {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_FieldArray[ind]);
            return false;
          }
        } else if (checkType == "c7") {
          if (!zf_ValidatePhone(fieldObj)) {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_FieldArray[ind]);
            return false;
          }
        } else if (checkType == "c8") {
          zf_ValidateSignature(fieldObj);
        } else if (checkType == "c9") {
          if (!zf_ValidateMonthYearFormat(fieldObj)) {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_FieldArray[ind]);
            return false;
          }
        }
      }
    }
  }
  return true;
}

function zf_ShowErrorMsg(uniqName, message) {
  var fldLinkName, errEl;
  if (typeof zf_FieldArray !== 'undefined') {
    for (var errInd = 0; errInd < zf_FieldArray.length; errInd++) {
      fldLinkName = zf_FieldArray[errInd].split('_')[0];
      errEl = document.getElementById(fldLinkName + "_error");
      if (errEl) errEl.style.display = 'none';
    }
  }
  var linkName = uniqName.split('_')[0];
  errEl = document.getElementById(linkName + "_error");
  if (errEl) {
    if (message) errEl.textContent = message;
    errEl.style.display = 'block';
  }
}

function zf_HideErrorMsg(uniqName) {
  var linkName = uniqName.split('_')[0];
  var errEl = document.getElementById(linkName + "_error");
  if (errEl) errEl.style.display = 'none';
}

function zf_GetErrorMsg(fieldName, type) {
  var msgs = zf_ErrorMessages[fieldName];
  if (msgs && msgs[type]) return msgs[type];
  return type === 'required' ? zf_GenericRequired : zf_GenericFormat;
}

function zf_ValidateNumber(elem) {
  var validChars = "-0123456789";
  var numValue = elem.value.replace(/^\s+|\s+$/g, '');
  if (numValue != null && !numValue == "") {
    var strChar;
    var result = true;
    if (numValue.charAt(0) == "-" && numValue.length == 1) {
      return false;
    }
    for (i = 0; i < numValue.length && result == true; i++) {
      strChar = numValue.charAt(i);
      if ((strChar == "-") && (i != 0)) {
        return false;
      }
      if (validChars.indexOf(strChar) == -1) {
        result = false;
      }
    }
    return result;
  } else {
    return true;
  }
}

function zf_ValidateDateFormat(inpElem) {
  var dateValue = inpElem.value.replace(/^\s+|\s+$/g, '');
  if (dateValue == "") {
    return true;
  } else {
    return (zf_DateRegex.test(dateValue));
  }
}

function zf_ValidateCurrency(elem) {
  var validChars = "0123456789.";
  var numValue = elem.value.replace(/^\s+|\s+$/g, '');
  if (numValue.charAt(0) == '-') {
    numValue = numValue.substring(1, numValue.length);
  }
  if (numValue != null && !numValue == "") {
    var strChar;
    var result = true;
    for (i = 0; i < numValue.length && result == true; i++) {
      strChar = numValue.charAt(i);
      if (validChars.indexOf(strChar) == -1) {
        result = false;
      }
    }
    return result;
  } else {
    return true;
  }
}

function zf_ValidateDecimalLength(elem, decimalLen) {
  var numValue = elem.value;
  if (numValue.indexOf('.') >= 0) {
    var decimalLength = numValue.substring(numValue.indexOf('.') + 1).length;
    if (decimalLength > decimalLen) {
      return false;
    } else {
      return true;
    }
  }
  return true;
}

function zf_ValidateEmailID(elem) {
  var check = 0;
  var emailValue = elem.value;
  if (emailValue != null && !emailValue == "") {
    var emailArray = emailValue.split(",");
    for (i = 0; i < emailArray.length; i++) {
      var emailExp = /^[\w]([\w\-.+&'/]*)@([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,22}$/;
      if (!emailExp.test(emailArray[i].replace(/^\s+|\s+$/g, ''))) {
        check = 1;
      }
    }
    if (check == 0) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
}

function zf_ValidateLiveUrl(elem) {
  var urlValue = elem.value;
  if (urlValue !== null && typeof(urlValue) !== "undefined") {
    urlValue = urlValue.replace(/^\s+|\s+$/g, '');
    if (urlValue !== "") {
      var urlregex = new RegExp("^(((https|http|ftps|ftp)://[a-zA-Z\\d]+((_|-|@)[a-zA-Z\\d]+)*(\\.[a-zA-Z\\d]+((_|-|@)[a-zA-Z\\d]+)*)+(:\\d{1,5})?)|((w|W){3}(\\.[a-zA-Z\\d]+((_|-|@)[a-zA-Z\\d]+)*){2,}(:\\d{1,5})?)|([a-zA-Z\\d]+((_|-)[a-zA-Z\\d]+)*(\\.[a-zA-Z\\d]+((_|-)[a-zA-Z\\d]+)*)+(:\\d{1,5})?))(/[-\\w.?,:'/\\\\+=&;%$#@()!~]*)?$", "i"); // This regex is taken from LiveFieldsUtil.isValidWebSiteFieldURL() method. Changes: i) Add ^ at the beginning and $ at the end. ii) Remove ?i before https and adjust () around https. iii) Add "i" in the RegExp constructor. // No I18N
      return (urlregex.test(urlValue));
    }
  }
  return true;
}

function zf_ValidatePhone(inpElem) {

  var ZFPhoneRegex = {
    PHONE_INTE_ALL_REG: /^[+]{0,1}[()0-9-. ]+$/,
    PHONE_INTE_NUMERIC_REG: /^[0-9]+$/,
    PHONE_INTE_CONT_CODE_ENABLED_REG: /^[(0-9-.][()0-9-. ]*$/,
    PHONE_USA_REG: /^[0-9]+$/,
    PHONE_CONT_CODE_REG: /^[+][0-9]{1,4}$/
  }
  var phoneFormat = parseInt(inpElem.getAttribute("phoneFormat"));
  var fieldInpVal = inpElem.value.replace(/^\s+|\s+$/g, '');
  var toReturn = true;
  if (phoneFormat === 1) {
    if (inpElem.getAttribute("valType") == 'code') {
      var codeRexp = ZFPhoneRegex.PHONE_CONT_CODE_REG;
      if (fieldInpVal != "" && !codeRexp.test(fieldInpVal)) {
        return false;
      }
    } else {
      var IRexp = ZFPhoneRegex.PHONE_INTE_ALL_REG;
      if (inpElem.getAttribute("phoneFormatType") == '2') {
        IRexp = ZFPhoneRegex.PHONE_INTE_NUMERIC_REG;
      }
      if (fieldInpVal != "" && !IRexp.test(fieldInpVal)) {
        toReturn = false;
        return toReturn;
      }
    }
    return toReturn;
  } else if (phoneFormat === 2) {
    var InpMaxlength = inpElem.getAttribute("maxlength");
    var USARexp = ZFPhoneRegex.PHONE_USA_REG;
    if (fieldInpVal != "" && USARexp.test(fieldInpVal) && fieldInpVal.length == InpMaxlength) {
      toReturn = true;
    } else if (fieldInpVal == "") {
      toReturn = true;
    } else {
      toReturn = false;
    }
    return toReturn;
  }
}

function zf_ValidateSignature(objElem) {
  var linkName = objElem.getAttribute("compname");
  var canvasElem = document.getElementById("drawingCanvas-" + linkName);
  var isValidSign = zf_IsSignaturePresent(objElem, linkName, canvasElem);
  var hiddenSignInputElem = document.getElementById("hiddenSignInput-" + linkName);
  if (isValidSign) {
    hiddenSignInputElem.value = canvasElem.toDataURL();
  } else {
    hiddenSignInputElem.value = ""; // No I18N
  }
  return isValidSign;
}

function zf_MandatoryCheckSignature(objElem) {
  var linkName = objElem.getAttribute("compname");
  var canvasElem = document.getElementById("drawingCanvas-" + linkName);
  var isValid = zf_IsSignaturePresent(objElem, linkName, canvasElem);
  return isValid;
}

function zf_IsSignaturePresent(objElem, linkName, canvasElem) {
  var context = canvasElem.getContext('2d'); // No I18N
  var canvasWidth = canvasElem.width;
  var canvasHeight = canvasElem.height;
  var canvasData = context.getImageData(0, 0, canvasWidth, canvasHeight);
  var signLen = canvasData.data.length;
  var flag = false;
  for (var index = 0; index < signLen; index++) {
    if (!canvasData.data[index]) {
      flag = false;
    } else if (canvasData.data[index]) {
      flag = true;
      break;
    }
  }
  return flag;
}

function zf_FocusNext(elem, event) {
  if (event.keyCode == 9 || event.keyCode == 16) {
    return;
  }
  if (event.keyCode >= 37 && event.keyCode <= 40) {
    return;
  }
  var compname = elem.getAttribute("compname");
  var inpElemName = elem.getAttribute("name");
  if (inpElemName == compname + "_countrycode") {
    if (elem.value.length == 3) {
      document.getElementsByName(compname + "_first")[0].focus();
    }
  } else if (inpElemName == compname + "_first") {
    if (elem.value.length == 3) {
      document.getElementsByName(compname + "_second")[0].focus();
    }
  }
}

function zf_ValidateMonthYearFormat(inpElem) {
  var monthYearValue = inpElem.value.replace(/^\s+|\s+$/g, '');
  if (monthYearValue == "") {
    return true;
  } else {
    return (zf_MonthYearRegex.test(monthYearValue));
  }
}

function zf_SetDateAndMonthRegexBasedOnDateFormate(dateFormat) {

  var dateAndMonthRegexFormateArray = new Array();
  var dateFormatRegExp;
  var monthYearFormatRegExp;
  if (dateFormat === "dd-MMM-yyyy") {

    dateFormatRegExp = "^(([0][1-9])|([1-2][0-9])|([3][0-1]))[-](Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[-](?:(?:19|20)[0-9]{2})$";
    monthYearFormatRegExp = "^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[-](?:(?:19|20)[0-9]{2})$"; // No I18N

  } else if (dateFormat === "dd-MMMM-yyyy") { // No I18N
    dateFormatRegExp = "^(([0][1-9])|([1-2][0-9])|([3][0-1]))[-](January|February|March|April|May|June|July|August|September|October|November|December|JANUARY|FEBRUARY|MARCH|APRIL|MAY|JUNE|JULY|AUGUST|SEPTEMBER|OCTOBER|NOVEMBER|DECEMBER)[-](?:(?:19|20)[0-9]{2})$";
    monthYearFormatRegExp = "^(January|February|March|April|May|June|July|August|September|October|November|December|JANUARY|FEBRUARY|MARCH|APRIL|MAY|JUNE|JULY|AUGUST|SEPTEMBER|OCTOBER|NOVEMBER|DECEMBER)[-](?:(?:19|20)[0-9]{2})$"; // No I18N

  } else if (dateFormat === "MMMM-dd-yyyy") { // No I18N
    dateFormatRegExp = "^(January|February|March|April|May|June|July|August|September|October|November|December|JANUARY|FEBRUARY|MARCH|APRIL|MAY|JUNE|JULY|AUGUST|SEPTEMBER|OCTOBER|NOVEMBER|DECEMBER)[-](([0][1-9])|([1-2][0-9])|([3][0-1]))[-](?:(?:19|20)[0-9]{2})$";
    monthYearFormatRegExp = "^(January|February|March|April|May|June|July|August|September|October|November|December|JANUARY|FEBRUARY|MARCH|APRIL|MAY|JUNE|JULY|AUGUST|SEPTEMBER|OCTOBER|NOVEMBER|DECEMBER)[-](?:(?:19|20)[0-9]{2})$"; // No I18N

  } else if (dateFormat === "dd/MM/yyyy") { // No I18N
    dateFormatRegExp = "^(([0][1-9])|([1-2][0-9])|([3][0-1]))[\/]([0][1-9]|1[012])[\/](?:(?:19|20)[0-9]{2})$";
    monthYearFormatRegExp = "^([0][1-9]|1[012])[\/](?:(?:19|20)[0-9]{2})$";

  } else if (dateFormat === "dd-MM-yyyy") { // No I18N
    dateFormatRegExp = "^(([0][1-9])|([1-2][0-9])|([3][0-1]))[-]([0][1-9]|1[012])[-](?:(?:19|20)[0-9]{2})$";
    monthYearFormatRegExp = "^([0][1-9]|1[012])[-](?:(?:19|20)[0-9]{2})$";

  } else if (dateFormat === "MM/dd/yyyy") { // No I18N
    dateFormatRegExp = "^([0][1-9]|1[012])[\/](([0][1-9])|([1-2][0-9])|([3][0-1]))[\/](?:(?:19|20)[0-9]{2})$";
    monthYearFormatRegExp = "^([0][1-9]|1[012])[\/](?:(?:19|20)[0-9]{2})$";

  } else if (dateFormat === "yyyy-MM-dd") { // No I18N
    dateFormatRegExp = "^(?:(?:19|20)[0-9]{2})[-]([0][1-9]|1[012])[-](([0][1-9])|([1-2][0-9])|([3][0-1]))$";
    monthYearFormatRegExp = "^(?:(?:19|20)[0-9]{2})[-]([0][1-9]|1[012])$";

  } else if (dateFormat === "yyyy/MM/dd") { // No I18N
    dateFormatRegExp = "^(?:(?:19|20)[0-9]{2})[\/]([0][1-9]|1[012])[\/](([0][1-9])|([1-2][0-9])|([3][0-1]))$";
    monthYearFormatRegExp = "^(?:(?:19|20)[0-9]{2})[\/]([0][1-9]|1[012])$";

  } else if (dateFormat === "dd.MM.yyyy") { // No I18N
    dateFormatRegExp = "^(([0][1-9])|([1-2][0-9])|([3][0-1]))[.]([0][1-9]|1[012])[.](?:(?:19|20)[0-9]{2})$";
    monthYearFormatRegExp = "^([0][1-9]|1[012])[.](?:(?:19|20)[0-9]{2})$";

  } else if (dateFormat === "MM-dd-yyyy") { // No I18N
    dateFormatRegExp = "^([0][1-9]|1[012])[-](([0][1-9])|([1-2][0-9])|([3][0-1]))[-](?:(?:19|20)[0-9]{2})$";
    monthYearFormatRegExp = "^([0][1-9]|1[012])[-](?:(?:19|20)[0-9]{2})$";
  }
  dateAndMonthRegexFormateArray.push(dateFormatRegExp);
  dateAndMonthRegexFormateArray.push(monthYearFormatRegExp);

  return dateAndMonthRegexFormateArray;
}

// **********
// CUSTOM
// **********
// Add today to date field
function zf_addDefaultDate() {
  const zf_date_field = document.getElementById("zf_date_field");

  if (!zf_date_field) return;

  const date = new Date();

  const day = date.getDate().toString().padStart(2, "0");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  
  zf_date_field.value = `${day}-${month}-${year}`;
}

function zf_enforceMaxCheckbox() {
  const checkboxGroups = document.querySelectorAll('.zf-checkbox');
  if (!checkboxGroups) return;

  checkboxGroups.forEach(group => {
    const max = parseInt(group.dataset.max, 10) || Infinity; // default to unlimited if no data-max
    const checkboxes = group.querySelectorAll('input[type="checkbox"]');

    // Function to enforce checkbox limits
    const enforceLimit = () => {
      // Count how many are checked in this group
      const checkedCount = Array.from(checkboxes).filter(cb => cb.checked).length;

      // Enable/disable based on the count
      if (checkedCount >= max) {
        checkboxes.forEach(cb => {
          if (!cb.checked) {
            cb.disabled = true;
          }
        });
      } else {
        checkboxes.forEach(cb => {
          cb.disabled = false;
        });
      }
    };

    // Enforce limits on page load
    enforceLimit();

    // Add change event listeners to enforce limits on user interaction
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', enforceLimit);
    });
  });
}

function zf_PushToDataLayer(formElement) {
  var formData = new FormData(formElement);
  var formDataObject = Object.fromEntries(formData);

  // Parse tracking mapping from data attribute
  var trackingMapping = {};
  var trackingData = formElement.dataset.tracking;
  
  if (trackingData) {
    // Parse the mapping string (handles comma and newline separation)
    var mappings = trackingData.split(/[,\n]/);
    
    for (var i = 0; i < mappings.length; i++) {
      var mapping = mappings[i].trim();
      if (mapping) {
        var colonIndex = mapping.indexOf(':');
        if (colonIndex > -1) {
          var key = mapping.substring(0, colonIndex).trim();
          var field = mapping.substring(colonIndex + 1).trim();
          trackingMapping[key] = field;
        }
      }
    }
  }

  // Build dataLayer object dynamically based on tracking mapping
  var dataLayerEvent = {
    event: "zf_submit"
  };

  // Process each mapping
  for (var key in trackingMapping) {
    var fieldName = trackingMapping[key];
    var fieldValue = "";
    
    if (fieldName && formDataObject.hasOwnProperty(fieldName)) {
      fieldValue = formDataObject[fieldName] || "";
    }
    
    dataLayerEvent[key] = fieldValue;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerEvent);
}

// **********
// MULTI-STEP
// **********
window.zfMultiStep = { active: false, currentStep: 1, totalSteps: 1, stepFieldsList: [] };

// Per-field error messages: { fieldName: { required: '...', format: '...' } }
// Fields not listed here fall back to generic messages.
var zf_ErrorMessages = {
  'Dropdown':                 { required: 'Bitte wähle eine Menge aus.' },
  'SingleLine':               { required: 'Bitte trage den Namen deines Vereins ein.' },
  'Name_First':               { required: 'Bitte trage deinen Vornamen ein.' },
  'Name_Last':                { required: 'Bitte trage deinen Nachnamen ein.' },
  'Email':                    { required: 'Bitte trage deine E-Mail-Adresse ein.', format: 'Bitte überprüfe das Format deiner E-Mail-Adresse.' },
  'PhoneNumber_countrycode':  { required: 'Bitte trage deine Telefonnummer ein.', format: 'Bitte überprüfe das Format deiner Telefonnummer.' },
  'TermsConditions':          { required: 'Bitte stimme den Datenschutzbestimmungen zu.' },
  'DecisionBox':              { required: 'Bitte wähle eine Option aus.' },
  'FileUpload':               { required: 'Bitte lade eine Datei hoch.' },
  'MultiLine':                { format: 'Bitte überprüfe deine Eingabe.' },
  'Address_AddressLine1':     { required: 'Bitte trage deine Straße und Hausnummer ein.' },
  'Address_ZipCode':          { required: 'Bitte trage deine Postleitzahl ein.' },
  'Address_City':             { required: 'Bitte trage deinen Ort ein.' }
};
var zf_GenericRequired = 'Dieses Feld ist erforderlich.';
var zf_GenericFormat   = 'Bitte überprüfe deine Eingabe.';

// Shared helpers to avoid duplicating logic across zf_ValidateStep, zf_ValidateField, etc.
function zf_IsFieldEmpty(fieldObj) {
  if (fieldObj.nodeName != null) {
    if (fieldObj.type === 'checkbox' || fieldObj.type === 'radio') return !fieldObj.checked;
    if (fieldObj.nodeName === 'SELECT') return fieldObj.options[fieldObj.selectedIndex].value === '-Select-';
    if (fieldObj.nodeName === 'OBJECT') return !zf_MandatoryCheckSignature(fieldObj);
    return (fieldObj.value.replace(/^\s+|\s+$/g, '')).length === 0;
  }
  // Radio/checkbox group (NodeList)
  var checked = 0;
  for (var j = 0; j < fieldObj.length; j++) { if (fieldObj[j].checked) checked++; }
  return checked === 0;
}

// Returns true if the field value has an invalid format (non-empty fields only).
function zf_CheckFormat(fieldObj) {
  if (!fieldObj || fieldObj.nodeName == null) return false;
  var ct = fieldObj.getAttribute('checktype');
  if (ct === 'c2') return !zf_ValidateNumber(fieldObj);
  if (ct === 'c3') return !zf_ValidateCurrency(fieldObj) || !zf_ValidateDecimalLength(fieldObj, 10);
  if (ct === 'c4') return !zf_ValidateDateFormat(fieldObj);
  if (ct === 'c5') return !zf_ValidateEmailID(fieldObj);
  if (ct === 'c6') return !zf_ValidateLiveUrl(fieldObj);
  if (ct === 'c7') return !zf_ValidatePhone(fieldObj);
  if (ct === 'c8') { zf_ValidateSignature(fieldObj); return false; }
  if (ct === 'c9') return !zf_ValidateMonthYearFormat(fieldObj);
  return false;
}

function zf_InitMultiStep() {
  var form = document.getElementById('form');
  if (!form) return;

  // Read all data-stepN-fields attributes to determine how many explicit steps are defined.
  // Each non-blank attribute creates a step with those fields; the final step always gets
  // all remaining fields (no attribute needed for it).
  var stepFieldsList = [];
  for (var i = 1; i <= 10; i++) {
    var attr = form.getAttribute('data-step' + i + '-fields');
    if (!attr) break;
    stepFieldsList.push(attr.split(',').map(function(f) { return f.trim(); }));
  }
  if (stepFieldsList.length === 0) return;

  // Total form steps = explicit field lists + 1 (last step always gets the remainder)
  var totalSteps = stepFieldsList.length + 1;

  // Collect and verify all step containers exist
  var stepContainers = [];
  for (var s = 1; s <= totalSteps; s++) {
    var container = form.querySelector('.zf-step[data-step="' + s + '"]');
    if (!container) return;
    stepContainers.push(container);
  }

  window.zfMultiStep.stepFieldsList = stepFieldsList;
  window.zfMultiStep.totalSteps = totalSteps;
  window.zfMultiStep.active = true;

  // Find Zoho structural elements
  var zohoFooter = form.querySelector('.zf-fmFooter');
  var zohoHeader = form.querySelector('.zf-tempHeadBdr');
  var zohoTemplateWrapper = form.querySelector('.zf-templateWrapper');

  // Hide Zoho's own header and submit button
  if (zohoHeader) zohoHeader.style.display = 'none';
  if (zohoFooter) zohoFooter.parentElement.style.display = 'none';

  // Get all field wrappers inside the template wrapper
  var allWrappers = [];
  if (zohoTemplateWrapper) {
    var subContWrap = zohoTemplateWrapper.querySelector('.zf-subContWrap');
    if (subContWrap) {
      var ul = subContWrap.querySelector('ul');
      if (ul) {
        allWrappers = Array.from(ul.children).filter(function(el) {
          return el.classList && el.classList.contains('zf-tempFrmWrapper');
        });
      }
    }
  }

  // Sort each wrapper into the correct step.
  // A wrapper belongs to the first step whose field list contains any of its input names.
  // Wrappers that don't match any explicit step go to the last step (remainder).
  allWrappers.forEach(function(wrapper) {
    var assignedStep = totalSteps;
    var inputs = wrapper.querySelectorAll('input, select, textarea, object');
    outer: for (var stepIdx = 0; stepIdx < stepFieldsList.length; stepIdx++) {
      var fields = stepFieldsList[stepIdx];
      for (var j = 0; j < inputs.length; j++) {
        var name = inputs[j].getAttribute('name') || '';
        for (var k = 0; k < fields.length; k++) {
          if (name === fields[k] || name.indexOf(fields[k] + '_') === 0) {
            assignedStep = stepIdx + 1;
            break outer;
          }
        }
      }
    }
    stepContainers[assignedStep - 1].appendChild(wrapper);
  });

  // Move terms & conditions to the last step
  if (zohoTemplateWrapper) {
    var termsWrapper = zohoTemplateWrapper.querySelector('.zf-termsandCond');
    if (termsWrapper) stepContainers[totalSteps - 1].appendChild(termsWrapper);
  }

  // Hide all steps except step 1
  for (var s = 2; s <= totalSteps; s++) {
    stepContainers[s - 1].style.display = 'none';
  }

  // Detect success state: sessionStorage flag (primary), query param, or data attribute (fallbacks).
  var showSuccess = false;
  try {
    if (sessionStorage.getItem('zf_submitted') === '1') {
      sessionStorage.removeItem('zf_submitted');
      showSuccess = true;
    }
  } catch(e) {}

  if (!showSuccess) {
    showSuccess = (document.querySelector('.zf-step-indicator[data-success="true"]') !== null)
      || window.location.search.indexOf('form=success') > -1;
  }

  if (showSuccess) zf_ShowSuccess();
}

function zf_ShowSuccess() {
  var form = document.getElementById('form');
  var successMsg = document.querySelector('.zf-success-message');
  var navs = document.querySelectorAll('.zf-step-nav');

  // Hide form and nav buttons
  if (form) form.style.display = 'none';
  navs.forEach(function(nav) { nav.style.display = 'none'; });

  // Show success message
  if (successMsg) successMsg.style.display = '';

  // Pass totalSteps + 2 so every indicator item (including the success item) turns green
  zf_UpdateStepIndicator(window.zfMultiStep.totalSteps + 2);

  // Scroll to form section
  var formAnchor = document.getElementById('nexo-zoho-form');
  if (formAnchor) {
    formAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function zf_GoToStep(stepNum) {
  if (!window.zfMultiStep.active) return;

  var form = document.getElementById('form');
  if (!form) return;

  // Validate current step before going forward
  if (stepNum > window.zfMultiStep.currentStep) {
    try {
      if (!zf_ValidateStep(window.zfMultiStep.currentStep)) return;
    } catch(e) {
      console.error('zf_ValidateStep error:', e);
      return;
    }
  }

  var totalSteps = window.zfMultiStep.totalSteps;

  // Show only the target step and its nav; hide all others
  for (var i = 1; i <= totalSteps; i++) {
    var stepEl = form.querySelector('.zf-step[data-step="' + i + '"]');
    var navEl = form.querySelector('[data-step-nav="' + i + '"]');
    if (stepEl) stepEl.style.display = (i === stepNum) ? '' : 'none';
    if (navEl) navEl.style.display = (i === stepNum) ? '' : 'none';
  }

  window.zfMultiStep.currentStep = stepNum;
  zf_UpdateStepIndicator(stepNum);

  // Scroll to form
  var formAnchor = document.getElementById('nexo-zoho-form');
  if (formAnchor) {
    formAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function zf_ValidateStep(stepNum) {
  var form = document.getElementById('form');
  if (!form) return true;

  var stepContainer = form.querySelector('.zf-step[data-step="' + stepNum + '"]');
  if (!stepContainer) return true;

  // Block submission if Zoho arrays not yet defined (inline script may have crashed)
  if (typeof zf_MandArray === 'undefined' || typeof zf_FieldArray === 'undefined') return false;

  // Hide all existing error messages first
  var allErrors = form.querySelectorAll('.zf-errorMessage');
  allErrors.forEach(function(el) { el.style.display = 'none'; });

  // Check mandatory fields within this step
  for (var i = 0; i < zf_MandArray.length; i++) {
    var fieldObj = document.forms.form[zf_MandArray[i]];
    if (!fieldObj) continue;

    var fieldEl = fieldObj.nodeName ? fieldObj : fieldObj[0];
    if (!fieldEl || !stepContainer.contains(fieldEl)) continue;

    if (zf_IsFieldEmpty(fieldObj)) {
      if (fieldObj.focus) fieldObj.focus();
      else if (fieldObj[0] && fieldObj[0].focus) fieldObj[0].focus();
      zf_ShowErrorMsg(zf_MandArray[i], zf_GetErrorMsg(zf_MandArray[i], 'required'));
      return false;
    }
  }

  // Check format validation for fields in this step
  for (var ind = 0; ind < zf_FieldArray.length; ind++) {
    var fieldObj = document.forms.form[zf_FieldArray[ind]];
    if (!fieldObj) continue;

    var fieldEl = fieldObj.nodeName ? fieldObj : fieldObj[0];
    if (!fieldEl || !stepContainer.contains(fieldEl)) continue;

    if (fieldObj.nodeName != null && zf_CheckFormat(fieldObj)) {
      fieldObj.focus();
      zf_ShowErrorMsg(zf_FieldArray[ind], zf_GetErrorMsg(zf_FieldArray[ind], 'format'));
      return false;
    }
  }

  return true;
}

function zf_UpdateStepIndicator(activeStep) {
  var items = document.querySelectorAll('.zf-step-indicator .zf-step-item');

  items.forEach(function(item) {
    var step = parseInt(item.getAttribute('data-step'), 10);
    item.classList.remove('active', 'completed');
    if (step < activeStep) {
      item.classList.add('completed');
    } else if (step === activeStep) {
      item.classList.add('active');
    }
  });
}

// Validate a single field on blur/change.
function zf_ValidateField(fieldName) {
  if (typeof zf_MandArray === 'undefined' || typeof zf_FieldArray === 'undefined') return;

  var fieldObj = document.forms.form[fieldName];
  if (!fieldObj) return;

  var isMandatory = zf_MandArray.indexOf(fieldName) > -1;
  var isEmpty = zf_IsFieldEmpty(fieldObj);

  if (isMandatory && isEmpty) {
    zf_ShowErrorMsg(fieldName, zf_GetErrorMsg(fieldName, 'required'));
    return;
  }

  if (!isEmpty && fieldObj.nodeName != null && zf_CheckFormat(fieldObj)) {
    zf_ShowErrorMsg(fieldName, zf_GetErrorMsg(fieldName, 'format'));
    return;
  }

  zf_HideErrorMsg(fieldName);
}

// Attach blur/change listeners to all form fields for real-time validation.
function zf_InitDropzone() {
  var inputs = document.querySelectorAll('.zf-tempContDiv > input[type="file"]');
  inputs.forEach(function(input) {
    var container = input.parentNode;

    // Build the visual zone
    var zone = document.createElement('div');
    zone.className = 'nzf-dropzone';
    zone.innerHTML =
      '<i class="fa-light fa-upload nzf-dropzone__icon" aria-hidden="true"></i>' +
      '<span class="nzf-dropzone__text">Drag &amp; Drop oder wähle eine Datei zum hochladen</span>' +
      '<span class="nzf-dropzone__sub">Vektordatei (EPS, AI) hochauflösende Bilddatei (JPG, PNG)</span>' +
      '<span class="nzf-dropzone__filename" style="display:none;"></span>';

    // Insert zone before the input, then move the input inside
    container.insertBefore(zone, input);
    zone.appendChild(input);

    // Allowed file extensions
    var allowedExtensions = ['eps', 'ai', 'jpg', 'jpeg', 'png'];

    // Show filename after selection + validate file type
    input.addEventListener('change', function() {
      var label = zone.querySelector('.nzf-dropzone__filename');
      var errorEl = document.getElementById('FileUpload_error');

      if (input.files && input.files.length > 0) {
        var file = input.files[0];
        var ext = file.name.split('.').pop().toLowerCase();

          if (file.size > 20 * 1024 * 1024) {
          // File too large — show inline error, clear the input
          if (errorEl) {
            errorEl.textContent = 'Die Datei ist zu groß. Maximale Dateigröße: 20 MB.';
            errorEl.style.display = 'block';
          }
          input.value = '';
          label.style.display = 'none';
          zone.classList.remove('nzf-dropzone--has-file');
          return;
        }

        if (allowedExtensions.indexOf(ext) === -1) {
          // Invalid type — show inline error, clear the input
          if (errorEl) {
            errorEl.textContent = 'Ungültiges Dateiformat. Erlaubt: EPS, AI, JPG, PNG.';
            errorEl.style.display = 'block';
          }
          input.value = '';
          label.style.display = 'none';
          zone.classList.remove('nzf-dropzone--has-file');
          return;
        }

        // Valid — clear any error and show filename
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.style.display = 'none';
        }
        label.textContent = file.name;
        label.style.display = 'block';
        zone.classList.add('nzf-dropzone--has-file');
      } else {
        label.style.display = 'none';
        zone.classList.remove('nzf-dropzone--has-file');
      }
    });

    // Drag-over visual state
    zone.addEventListener('dragover', function(e) {
      e.preventDefault();
      zone.classList.add('nzf-dropzone--dragover');
    });
    zone.addEventListener('dragleave', function() {
      zone.classList.remove('nzf-dropzone--dragover');
    });
    zone.addEventListener('drop', function() {
      zone.classList.remove('nzf-dropzone--dragover');
    });
  });
}

function zf_InitBlurValidation() {
  var form = document.getElementById('form');
  if (!form) return;

  var inputs = form.querySelectorAll('input, select, textarea');
  inputs.forEach(function(inp) {
    var name = inp.getAttribute('name');
    if (!name) return;

    if (inp.type === 'checkbox' || inp.type === 'radio') {
      inp.addEventListener('change', function() {
        zf_ValidateField(name);
      });
    } else {
      inp.addEventListener('blur', function() {
        // Only validate if the field actually has content
        if (inp.value.trim().length > 0) {
          zf_ValidateField(name);
        }
      });
    }
  });
}

zf_addDefaultDate();
zf_enforceMaxCheckbox();
zf_InitMultiStep();
zf_InitBlurValidation();
zf_InitDropzone();

// Prevent terms links from toggling the checkbox when clicked
document.querySelectorAll('.zf-termsAccept .zf-descFld a').forEach(function(a) {
  a.addEventListener('click', function(e) { e.stopPropagation(); });
});

// Re-setup date regex.
if (window._zfDateFmt) {
  var dateAndMonthRegexFormateArray = zf_SetDateAndMonthRegexBasedOnDateFormate(window._zfDateFmt);
  zf_DateRegex = new RegExp(dateAndMonthRegexFormateArray[0]);
  zf_MonthYearRegex = new RegExp(dateAndMonthRegexFormateArray[1]);
} else if (typeof zf_DateFormat !== 'undefined') {
  var dateAndMonthRegexFormateArray = zf_SetDateAndMonthRegexBasedOnDateFormate(zf_DateFormat);
  zf_DateRegex = new RegExp(dateAndMonthRegexFormateArray[0]);
  zf_MonthYearRegex = new RegExp(dateAndMonthRegexFormateArray[1]);
}